import { Label } from "@xola/ui-kit";
import { SwitchField } from "common";
import { useFormikContext } from "formik";
import React from "react";
import { FraudPreference } from "types";
import { NumberInlineValuePopover } from "@/components/Common/NumberInlineValuePopover";
import { useModal } from "@/hooks/useVisibility";

interface FormValues {
    fraud: FraudPreference;
}

const DEFAULT_AMOUNT = 0;

export const ThreeDSecureSection = () => {
    const { values, setFieldValue } = useFormikContext<FormValues>();
    const amountPopover = useModal(false);

    const isEnabled = values.fraud.threeDSecureTriggerAmount !== null;
    const amount = values.fraud.threeDSecureTriggerAmount ?? DEFAULT_AMOUNT;

    const handleToggleChange = (isChecked: boolean) => {
        setFieldValue("fraud.threeDSecureTriggerAmount", isChecked ? DEFAULT_AMOUNT : null);
    };

    const handleAmountChange = (value: number) => {
        setFieldValue("fraud.threeDSecureTriggerAmount", value ?? 0);
    };

    return (
        <div data-testid="fraud-fighter-3d-secure-section">
            <Label>3D Secure Trigger</Label>
            <SwitchField isChecked={isEnabled} onChange={handleToggleChange}>
                <span className="text-gray-darker">
                    {isEnabled ? (
                        <>
                            Enforce 3D Secure when the purchase amount exceeds
                            <span onClick={(e) => e.stopPropagation()}>
                                <NumberInlineValuePopover
                                    isOpen={amountPopover.isVisible}
                                    value={amount}
                                    min={0}
                                    step="1"
                                    text={
                                        <b>
                                            $ <var data-var="amount">{amount}</var>
                                        </b>
                                    }
                                    onOpenChange={amountPopover.set}
                                    onChange={handleAmountChange}
                                />
                            </span>
                        </>
                    ) : (
                        "Enforce 3D Secure when the purchase amount exceeds a given value"
                    )}
                </span>
            </SwitchField>
        </div>
    );
};
